import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    container:
      'flex h-[375px] w-full flex-col justify-center gap-12 bg-[image:var(--footer-bg-sm)] bg-cover bg-center px-3 md:h-[210px] md:gap-7 md:bg-[image:var(--footer-bg-md)] lg:px-[58px]',
    top: 'flex flex-wrap justify-between gap-7',
    bottom:
      'flex flex-col items-baseline justify-between gap-2 md:flex-row md:gap-6',
    logo: 'flex items-center gap-2',
    logoImage: 'max-md:max-w-[170px]',
    text: 'pl-1 text-[17px] leading-[1.2] font-light tracking-[0.05em] text-white uppercase md:pl-2 md:text-lg md:tracking-[0.09em]',
    list: 'flex flex-wrap gap-3 pt-[5px] text-base leading-[1.5] font-light md:gap-2 md:text-sm lg:gap-8',
    listItem: 'w-full text-white md:w-auto',
    link: 'text-base font-light text-white underline underline-offset-[3px] md:text-sm',
    phone: 'text-[22px] leading-[1.7] whitespace-nowrap text-white',
    footnotes:
      'my-10 flex max-w-246 flex-col px-3 text-[#A6A6A6] lg:my-20 lg:px-[49px]',
    footnote: 'text-[12px] leading-[1.36]'
  }
});
